import { render } from "./FavoritesPage.vue?vue&type=template&id=48998224&scoped=true&ts=true"
import script from "./FavoritesPage.vue?vue&type=script&lang=ts"
export * from "./FavoritesPage.vue?vue&type=script&lang=ts"

import "./FavoritesPage.vue?vue&type=style&index=0&id=48998224&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48998224"]])

export default __exports__